import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeLocaleModule: LocaleModule = {
  name: "employee",
  messages: { en: en, it: it },
};
